/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { UserPlayerErrorMessage } from "../../BasePlayer";

import { ErrorDialog } from "./Component";

interface ErrorOverlayProps {
  error: UserPlayerErrorMessage;
}

export const ErrorOverlay = (props: ErrorOverlayProps) => {
  const { error } = props;

  return (
    <div className="OverlayContainer">
      <div className="OverlayContainer__CenterSection">
        <ErrorDialog error={error} />
      </div>
    </div>
  );
};
